import { PageContainer, PageTitleBadge } from "../components";
import { useTranslation } from "../context/LanguageContext";
import { FaCog } from "react-icons/fa";
import "../styles/common.css";
import "./Parametres.css";

export default function Parametres() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <PageTitleBadge 
        title={t.pages["/parametres"] || t.settings || "Paramètres"} 
        icon={<FaCog />} 
      />
      
      <div className="parametres-container">
        <div style={{ 
          padding: "2rem", 
          textAlign: "center",
          color: "#666"
        }}>
          <p style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>
            {t.pageUnderConstruction}
          </p>
          <p>
            {t.settingsComingSoon}
          </p>
        </div>
      </div>
    </PageContainer>
  );
}
